import { Observable } from 'rxjs';

export interface GasStatusTag<T> {
  label: string;
  value: T;
  disabled$?: Observable<boolean>;
}

export enum GasStatusTagTypeEnum {
  Checkbox = 'checkbox',
  Radio = 'radio',
}

export type GasStatusTagType = GasStatusTagTypeEnum.Checkbox | GasStatusTagTypeEnum.Radio | GasStatusTagTypeEnum;
